import axios from "axios";
import { API_URL,SERVER_URL } from '../Constants';

class ProcurementTrackerService{
    getAllProjects(accessToken) {
        return axios.get(`${API_URL}getAllProcurementProjects/`,{headers:{'Authorization':accessToken}});
    };

    getProjectSubmittals(projectId, accessToken) {
        return axios.get(`${API_URL}getProcurementProjectSubmittals/${projectId}`,{headers:{'Authorization':accessToken}});
    };

    getVendors(accessToken) {
        return axios.get(`${API_URL}getAllProcurementVendors/`,{headers:{'Authorization':accessToken}});
    };

    getSubmittalStatuses(accessToken) {
        return axios.get(`${API_URL}getSubmittalStatuses/`,{headers:{'Authorization':accessToken}});
    };

    syncProcoreSubmittalStatuses(projectId, projectNumber, accessToken) {
        return axios.post(`${API_URL}syncProcoreSubmittalStatus`, { projectId, projectNumber }, { headers: { 'Authorization': accessToken } });
    };

    syncProjectSchedule(projectNumber, projectSchedule, accessToken) {
        return axios.post(`${API_URL}syncProjectProcurementSchedule`, { projectNumber, projectSchedule }, { headers: { 'Authorization': accessToken } });
    };

    // WORKFLOWS
    getAllWorkflows(accessToken) {
        return axios.get(`${API_URL}getAllProcurementWorkflows/`,{headers:{'Authorization':accessToken}});
    };

    createNewWorkflow(workflowData, accessToken) {
        return axios.post(`${API_URL}createProcurementWorkflow/`, workflowData,{headers:{'Authorization':accessToken}});
    };

    updateWorkflow(workflowId, workflowData, accessToken) {
        return axios.post(`${API_URL}updateProcurementWorkflow/${workflowId}`, workflowData,{headers:{'Authorization':accessToken}});
    };

    deleteWorkflow(workflowId, accessToken) {
        return axios.post(`${API_URL}deleteProcurementWorkflow/${workflowId}`, {},{headers:{'Authorization':accessToken}});
    };


    // ROLES
    getAllRoles(accessToken) {
        return axios.get(`${API_URL}getAllProcurementRoles/`,{headers:{'Authorization':accessToken}});
    };

    createNewRole(roleData, accessToken) {
        return axios.post(`${API_URL}createProcurementRole/`, roleData,{headers:{'Authorization':accessToken}});
    };

    updateRole(roleId, roleData, accessToken) {
        return axios.post(`${API_URL}updateProcurementRole/${roleId}`, roleData,{headers:{'Authorization':accessToken}});
    };

    deleteRole(roleId, roleData, accessToken) {
        return axios.post(`${API_URL}deleteProcurementRole/${roleId}`, roleData,{headers:{'Authorization':accessToken}});
    };

    // LINE ITEMS
    getProjectLineItems(projectId, accessToken) {
        return axios.get(`${API_URL}getProcurementProjectLineItems/${projectId}`,{headers:{'Authorization':accessToken}});
    };

    createNewLineItem(lineItemData, accessToken) {
        return axios.post(`${API_URL}createProcurementLineItem/`, lineItemData,{headers:{'Authorization':accessToken}});
    };

    updateLineItem(lineItemData, accessToken) {
        return axios.post(`${API_URL}updateProcurementLineItem/`, lineItemData,{headers:{'Authorization':accessToken}});
    };

    deleteLineItem(lineItemId, accessToken) {
        return axios.post(`${API_URL}deleteProcurementLineItem/${lineItemId}`, {},{headers:{'Authorization':accessToken}});
    }

    // VENDOR LINKS
    getProjectVendorLinkData(sessionId) {
        return axios.get(`${API_URL}getProcurementLinkData/${sessionId}`);
    };

    submitVendorLinkEdits(sessionId, vendorData) {
        return axios.post(`${API_URL}submitProcurementLinkEdits/${sessionId}`, vendorData);
    };
};

ProcurementTrackerService = new ProcurementTrackerService();
export default ProcurementTrackerService;